import store from "@saas/store/src";

export const checkPermission = (perm) => {
  const allPerms = store.state.user.permissions || [];
  if (!perm || allPerms.includes("*")) {
    return true;
  }
  let havePermission = false;
  if (Array.isArray(perm)) {
    havePermission = perm.some((item) => {
      return allPerms.includes(item);
    });
  } else {
    havePermission = allPerms.includes(perm);
  }
  return havePermission;
};
